export const styleColor = {
  success: {
    bg: 'brandGreen',
    color: 'white',
  },
  info: {
    bg: 'lightContentGrey',
    color: 'white',
  },
  warn: {
    bg: 'brandYellow',
    color: 'darkContentGrey',
  },
  error: {
    bg: 'alertRed',
    color: 'white',
  },
};
